import { FC, useEffect } from 'react';
import { isLangAvailable, useStores } from 'index';

import Layout from 'components/Layout/Layout';
import { ThemeProvider } from '@trackman/web-shared-components';
import i18next from 'i18next';
import { observer } from 'mobx-react-lite';
// scss
import './assets/styles/index.scss';

type Props = {
  children?: React.ReactNode;
};

export const App: FC<Props> = observer((props) => {
  const ss = useStores().startupStore;
  const as = useStores().analyticsStore;
  as.initApplicationInsights();
  
  useEffect(() => {
    if (!ss.hasBearerToken && !ss.isInitializing) ss.initialize();
  }, [ss]);

  useEffect(() => {
    if (ss.bearerTokenProfileInfo) i18next.changeLanguage(isLangAvailable(ss.bearerTokenProfileInfo.preferredLanguage) || 'en');
  }, [ss.bearerTokenProfileInfo]);

  return (
    <ThemeProvider>
      <Layout>{props.children}</Layout>
    </ThemeProvider>
  );
});

export default App;
